// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18gWB{will-change:opacity,transform;max-width:100%}._18gWB,.zKJpf{position:absolute;border-radius:24px}.zKJpf{width:50%;-webkit-box-shadow:0 4px 32px rgba(98,168,253,.08);box-shadow:0 4px 32px rgba(98,168,253,.08);padding:2rem;color:#0373f9}.Actuz{font-size:32px;font-size:2rem;font-weight:500;line-height:40px;line-height:2.5rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){.Actuz{font-size:1.625rem;line-height:2.03125rem}}.aekfb{font-size:16px;font-size:1rem;font-weight:400;line-height:26px;line-height:1.625rem;font-family:var(--base-font)}._3GZPN{width:33.69%}._3rBX8,._3GZPN{position:absolute;border-radius:24px}._3rBX8{width:43.8%}._2wtDr{position:absolute;bottom:0;width:100%;height:100%;will-change:opacity,transform;max-width:100%}._3yR_n{top:30%}._2nGzr{right:0;top:55%}._3KATf{top:24%;right:0}._1xtKh{top:30%}._23jE-{right:0;top:40%}.FnZMf{top:82%;left:0}.Ym1RS{top:48%}._1Y8I6{right:0;top:30%}._3m60K{top:82%;right:0}._1z38r{width:100%;border-radius:24px;aspect-ratio:1248/586.2}", ""]);
// Exports
exports.locals = {
	"imageFull": "_18gWB",
	"info": "zKJpf",
	"infoTitle": "Actuz",
	"infoText": "aekfb",
	"imageVertical": "_3GZPN",
	"imageHorizontal": "_3rBX8",
	"groupTwo": "_2wtDr",
	"typeOneImageLeft": "_3yR_n",
	"typeOneImageRight": "_2nGzr",
	"typeOneInfo": "_3KATf",
	"typeTwoImageLeft": "_1xtKh",
	"typeTwoImageRight": "_23jE-",
	"typeTwoInfo": "FnZMf",
	"typeThreeImageLeft": "Ym1RS",
	"typeThreeImageRight": "_1Y8I6",
	"typeThreeInfo": "_3m60K",
	"fullLoading": "_1z38r"
};
module.exports = exports;
